import { useAppState } from 'src/state';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs'

export function OperationsAdminVenueTalentBreadCrumb({}:BreadcrumbComponentProps): React.ReactElement {
    const { currentItem } = useAppState().users
    if (!currentItem) return <span>Talent</span>;
    return (
        <span>{`${currentItem?.first_name} ${currentItem?.first_name} ${!!currentItem?.alias ? `(${currentItem?.alias})` : ''}`}</span>
    );
}